import { Component, OnInit } from '@angular/core';
import { ShopService } from '../../services/shop.service';
import { ProductI } from '../../shared/product.interface';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-pedidos',
  templateUrl: './pedidos.component.html',
  styleUrls: ['./pedidos.component.scss']
})
export class PedidosComponent implements OnInit {

  lista: any;
  request: any;
  idBuyer: string;
  delivery: any;

  ciudad: string;
  direccion: string;
  nombre: string;
  telefono: string;

  cliente: any;
  carrito: any;
  listSec: any;

  prodCompra: any;
  cantAct: number;
  cantCompra: number;
  newdatainvent = {
    idprod:'',
    cant: 0
  }
  inventario = [];
  idCompra: any;

  constructor(private shopSvc: ShopService) { }

  ngOnInit(): void {
    this.shopSvc.loadSalesAdmin().subscribe(res => {
      this.lista = res;
      this.listSec = res
      console.log(this.lista);
      
    });
  }

  filterByState(event){
    if (event !== '') {
      if (event !== 'todos') {
        this.lista = '';
        this.shopSvc.loadSalesAdminByState(event)
                      .subscribe(res => {
                        this.lista = res;
                        event = '';
                      });
      } else {
        this.lista = this.listSec;
      }
    }
  }

  filterByRef(refer: number){
    const rfr = Number(refer);
    this.lista = '';
    this.shopSvc.loadSalesAdminByReference(rfr)
                   .subscribe(res => {
                      this.lista = res;
                      if (res.length === 0) {
                        Swal.fire({
                          icon: 'error',
                          title: 'Referencia no encontrada.',
                          text: 'Verifica la referencia ingresada.',
                        });
                        this.lista = this.listSec;
                      }
                   });
  }

  detailRequest(item: any){
    console.log(item);
    this.cliente = item.cliente;
    this.carrito = item.compras;
  }

  approve(idCompra: string, compra: any){
    console.log(compra);
    this.idCompra = idCompra;
    this.inventario = [];
    for (const key in compra) {      
      this.cantAct = 0;
      this.cantCompra = 0;
      this.shopSvc.cargarproducto(compra[key].idprod)
                  .subscribe(res => {
                    this.prodCompra = res;
                    this.cantAct = this.prodCompra.cantidad;
                    this.cantCompra = compra[key].cantidad;
                    if (this.cantAct >= this.cantCompra) {
                      let newCant = this.cantAct - this.cantCompra;
                      this.newdatainvent.idprod = compra[key].idprod;
                      this.newdatainvent.cant = newCant;
                      this.inventario.push(this.newdatainvent);
                      this.newdatainvent = {
                        idprod:'',
                        cant: 0
                      }
                    } else {
                      Swal.fire(
                        'Inventario insuficiente',
                        'La cantidad solicitada es superior a la disponible',
                        'error'
                      )
                    }
                  });
    }
    for (const key in this.inventario) {
      if (this.inventario[key].cant < 0) {
        Swal.fire('Inventario insuficiente, verfique productos por favor');
      }
    }
    console.log(this.inventario);  
  }

  aprovarVenta(){
   for (const key in this.inventario) {
     console.log(this.inventario[key].idprod, this.inventario[key].cant);
     this.shopSvc.actualizaInventario(this.inventario[key].idprod, this.inventario[key].cant);
     this.shopSvc.aproveSale(this.idCompra).then(() => {
      Swal.fire(
        'Aprobado!',
        'El pedido ha sido aprobado.',
        'success'
      );
    });
   }
  }

  enviarpedido(idCompra: string){
    Swal.fire({
      title: 'Está seguro?',
      text: "Se va a despachar este pedido!",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Si, enviar!',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.shopSvc.sendSale(idCompra).then(() => {
          Swal.fire(
            'Enviado!',
            'El pedido ha sido envidado al cliente.',
            'success'
          );
        });
      }
    });
  }


  deny(idSale: string){
    Swal.fire({
      title: 'Está seguro?',
      text: "Se va a eliminar por completo este pedido!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.shopSvc.pedidosCancelados(idSale).then(()=> {
          Swal.fire(
            'Eliminado!',
            'El pedido ha sido borrado.',
            'success'
          )
        });
      }
    });
  }

  whatsappcliente(cel: any){
    console.log(cel);  
    cel = '57'+cel;
    window.open(`https://wa.me/${cel}`, "_blank");  
  }

}
